<div class="flex layout-row">
  <mat-form-field>
    <elder-select
      name="attachmentSpecType"
      appAttachmentSpecTypeSelect
      valueAsId
      [(ngModel)]="attachment().type"
    >
    </elder-select>
  </mat-form-field>
  <div class="layout-row place-start-center gap-lg">
    @switch (attachment().type) {
      @case (AttachmentSpecType.DESIGN_IMAGE || AttachmentSpecType.SEGMENT_IMAGE) {
        <div>
          <!-- No configurations necessary -->
        </div>
      }
      @case (AttachmentSpecType.REMOTE_ATTACHMENT) {
        <div class="layout-row place-start-center gap-lg">
          <mat-form-field>
            <elder-select
              appAttachmentTypeSelect
              name="attachmentType"
              required
              [allowNull]="true"
              [nullDisplay]="'context.noSelection' | translate"
              valueAsId
              [(ngModel)]="attachment().typeId"
            >
            </elder-select>
          </mat-form-field>
          <mat-form-field>
            <elder-select
              appEntitySelect
              name="scope"
              required
              [allowNull]="true"
              [nullDisplay]="'context.noSelection' | translate"
              valueAsId
              [(ngModel)]="attachment().scope"
            >
            </elder-select>
          </mat-form-field>
          <elder-label-input
            class="flex"
            name="labels"
            [(ngModel)]="attachment().labels"
            placeholder="{{ 'context.labels' | translate }}"
          >
          </elder-label-input>
        </div>
      }
    }
  </div>
</div>
